document.addEventListener("DOMContentLoaded", function() {

  function updatePrice(currentVariant, container) {
    if (!currentVariant) return;

    function normaliseAtcPrice(raw, currency) {
      raw = (raw || "").trim();
      currency = (currency || "").trim();

      raw = raw.replace(/\.00(?=\s*[A-Z]{3}$|$)/, "");
      raw = raw.replace(/,/g, ".");

      if (currency) {
        var esc = currency.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        if (!new RegExp("\\s" + esc + "$").test(raw)) {
          raw = raw + " " + currency;
        }
      }

      return raw.trim();
    }

    var raw = currentVariant.dataset.price || "";
    var currency = currentVariant.dataset.currency || "";
    var formatted = normaliseAtcPrice(raw, currency);

    // Update inline ATC price (if present)
    var atcPrice = container.querySelector(".sic-atc-price");
    if (atcPrice) {
      atcPrice.textContent = formatted;
    }

    // IMPORTANT:
    // Keep legacy price updated for any dependent logic (necklace / pendant)
    container.querySelectorAll(".js-product-price")?.forEach(function(el) {
      el.innerHTML = formatted;
    });
  }

  function updateAddToCart(currentVariant) {
    document.querySelectorAll('.js-atc-btn')?.forEach(function(btn) {
      if (currentVariant.dataset.available === 'true') {
        btn.removeAttribute('disabled');
      } else {
        btn.setAttribute('disabled', true);
      }
    });
  }

  function checkOptionsMatch(currentOptions, variantDataset) {
    for (const key in currentOptions) {
      if (
        variantDataset.hasOwnProperty(key) &&
        currentOptions[key] !== variantDataset[key]
      ) {
        return false;
      }
    }
    return true;
  }

  function changeVariant(currentVariant, container) {
    if (!currentVariant) return;

    var variantSelector = container.querySelector(".js-all-variants");
    if (variantSelector) {
      variantSelector.value = currentVariant.value;
    }

    updatePrice(currentVariant, container);
    updateAddToCart(currentVariant);

    var color = getValueByOption('color', currentVariant);
    if (color) {
      container.dataset.metal = color;
      changeProductImage(color, container);
    }

    var metal = getValueByOption('metal', currentVariant);
    if (metal) {
      container.dataset.metal = metal;
      changeProductImage(metal, container);
    }

    var stone = getValueByOption('stone', currentVariant);
    if (stone) {
      container.dataset.stone = stone;
      changeStoneColor(stone, container);
    }

    var select = container.querySelector('#ProductSelect');
    if (select) {
      select.value = currentVariant.value;
    }
  }

  function getValueByOption(option, currentVariant) {
    if (currentVariant.dataset['option-1Key']?.includes(option)) {
      return currentVariant.dataset['option-1'];
    }
    if (currentVariant.dataset['option-2Key']?.includes(option)) {
      return currentVariant.dataset['option-2'];
    }
    if (currentVariant.dataset['option-3Key']?.includes(option)) {
      return currentVariant.dataset['option-3'];
    }
    return false;
  }

  function changeProductImage(color, container) {
    if (!color) return;

    container.querySelectorAll('[data-metal-image]')?.forEach(function(image) {
      image.style.display = 'none';
    });

    var img = container.querySelector('[data-metal-image="' + color + '"]');
    if (img) {
      img.style.display = 'block';
    }
  }

  function changeStoneColor(color, container) {
    setTimeout(function() {
      if (typeof window.onNeckInput === 'function') {
        window.onNeckInput(container);
      }
    }, 100);
  }

  document.querySelectorAll(".js-product-option")?.forEach(function(btn) {
    var container = btn.closest(".js-product-form");
    if (!container) return;

    btn.addEventListener("click", function() {
      btn.closest(".js-options-group")
        .querySelectorAll(".js-product-option")
        .forEach(function(b) {
          b.classList.remove("active");
        });

      btn.classList.add("active");

      var currentVariant;
      var currentOptions = {};

      container.querySelectorAll(".js-product-option.active")
        .forEach(function(option) {
          const key = `option-${option.dataset.index}`;
          currentOptions[key] = option.value;
        });

      container.querySelectorAll(".js-all-variants option")
        .forEach(function(variant) {
          if (checkOptionsMatch(currentOptions, variant.dataset)) {
            currentVariant = variant;
          }
        });

      changeVariant(currentVariant, container);
    });
  });

  function getCurrentVariant(container) {
    var selector = container.querySelector(".js-all-variants");
    if (!selector) return null;
    return selector.options[selector.selectedIndex];
  }

  document.querySelectorAll(".js-product-form")?.forEach(function(container) {
    changeVariant(getCurrentVariant(container), container);
  });

});